var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import WixComponent from '../BaseComponents/WixComponent';
import ReactDOM from 'react-dom';

import TooltipContent from './TooltipContent';
import position from './TooltipPosition';

import styles from './TooltipContent.scss';

var renderSubtreeIntoContainer = ReactDOM.unstable_renderSubtreeIntoContainer;

var Tooltip = function (_WixComponent) {
  _inherits(Tooltip, _WixComponent);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tooltip, [{
    key: 'componentElements',
    value: function componentElements() {
      var elements = _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), 'componentElements', this).call(this);
      return this._mountNode ? elements.concat(this._mountNode) : elements;
    }
  }, {
    key: 'onClickOutside',
    value: function onClickOutside(e) {
      if (this.props.shouldCloseOnClickOutside) {
        this.hide();
      } else if (this.props.onClickOutside) {
        this.props.onClickOutside && this.props.onClickOutside(e);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this._mountNode && this.state.visible) {
        var arrowPlacement = { top: 'bottom', left: 'right', right: 'left', bottom: 'top' };
        var _position = this.props.relative ? 'relative' : 'absolute';
        var tooltip = React.createElement(
          TooltipContent,
          {
            onMouseEnter: function onMouseEnter() {
              return _this2._onTooltipContentEnter();
            },
            onMouseLeave: function onMouseLeave() {
              return _this2._onTooltipContentLeave();
            },
            ref: function ref(_ref2) {
              if (_this2.props.relative) {
                _this2.tooltipContent = _ref2.tooltip;
              } else {
                _this2.tooltipContent = _ref2;
              }
            },
            theme: this.props.theme,
            bounce: this.props.bounce,
            arrowPlacement: arrowPlacement[this.props.placement],
            style: { zIndex: this.props.zIndex, position: _position },
            padding: this.props.padding,
            arrowStyle: this.state.arrowStyle,
            maxWidth: this.props.maxWidth,
            size: this.props.size,
            textAlign: this.props.textAlign
          },
          this.props.content
        );

        renderSubtreeIntoContainer(this, tooltip, this._mountNode);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), 'componentWillUnmount', this) && _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), 'componentWillUnmount', this).call(this);
      this._unmounted = true;
      this._getContainer() && this.hide();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), 'componentWillMount', this) && _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), 'componentWillMount', this).call(this);
      if (this.props.active) {
        this.show();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), 'componentWillReceiveProps', this) && _get(Tooltip.prototype.__proto__ || Object.getPrototypeOf(Tooltip.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
      if (nextProps.active !== this.props.active) {
        if (this.state.visible && this.props.hideTrigger === 'custom') {
          if (!nextProps.active) {
            this.hide();
          }
        }
        if (!this.state.visible && this.props.showTrigger === 'custom') {
          if (nextProps.active) {
            this.show();
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var child = Array.isArray(this.props.children) ? this.props.children[0] : this.props.children;
      if (child) {
        return cloneElement(child, {
          ref: function ref(_ref3) {
            return _this3._childNode = ReactDOM.findDOMNode(_ref3);
          },
          onClick: this._chainCallbacks(child.props ? child.props.onClick : null, this._onClick),
          onMouseEnter: this._chainCallbacks(child.props ? child.props.onMouseEnter : null, this._onMouseEnter),
          onMouseLeave: this._chainCallbacks(child.props ? child.props.onMouseLeave : null, this._onMouseLeave),
          onFocus: this._chainCallbacks(child.props ? child.props.onFocus : null, this._onFocus),
          onBlur: this._chainCallbacks(child.props ? child.props.onBlur : null, this._onBlur)
        });
      } else {
        return React.createElement('div', null);
      }
    }
  }, {
    key: '_getContainer',
    value: function _getContainer() {
      if (typeof document === 'undefined') {
        return null;
      }

      return this.props.appendToParent ? this._childNode.parentElement : document ? document.body : null;
    }
  }, {
    key: 'show',
    value: function show() {
      var _this4 = this;

      if (this.props.disabled) {
        return;
      }
      if (this._unmounted) {
        return;
      }
      this.setState({ hidden: false });
      if (this._hideTimeout) {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = null;
      }
      if (this._showTimeout) {
        return;
      }
      if (!this.state.visible) {
        this._showTimeout = setTimeout(function () {
          if (typeof document === 'undefined') {
            return;
          }
          if (_this4.props.onShow) {
            _this4.props.onShow();
          }

          _this4.setState({ visible: true }, function () {
            if (!_this4._mountNode) {
              _this4._mountNode = document.createElement('div');
              _this4._getContainer() && _this4._getContainer().appendChild(_this4._mountNode);
            }
            _this4._showTimeout = null;

            var fw = 0;
            var sw = 0;
            do {
              _this4.componentDidUpdate();
              var tooltipNode = ReactDOM.findDOMNode(_this4.tooltipContent);
              fw = _this4._getRect(tooltipNode).width;
              _this4._updatePosition(_this4.tooltipContent);
              sw = _this4._getRect(tooltipNode).width;
            } while (!_this4.props.appendToParent && fw !== sw);
          });
        }, this.props.showDelay);
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      var _this5 = this;

      this.setState({ hidden: true });
      if (this._showTimeout) {
        clearTimeout(this._showTimeout);
        this._showTimeout = null;
      }

      if (this._hideTimeout) {
        return;
      }

      if (this.state.visible) {
        this._hideTimeout = setTimeout(function () {
          if (_this5._mountNode) {
            ReactDOM.unmountComponentAtNode(_this5._mountNode);
            _this5._getContainer() && _this5._getContainer().removeChild(_this5._mountNode);
            _this5._mountNode = null;
          }
          _this5._hideTimeout = null;
          if (!_this5._unmounted) {
            _this5.setState({ visible: false });
          }
        }, this._unmounted ? 0 : this.props.hideDelay);
      }
    }
  }, {
    key: '_hideOrShow',
    value: function _hideOrShow(event) {
      if (this.props.hideTrigger === event && !this.state.hidden) {
        this.hide();
      } else if (this.props.showTrigger === event) {
        this.show();
      }
    }
  }, {
    key: '_onBlur',
    value: function _onBlur() {
      this._hideOrShow('blur');
    }
  }, {
    key: '_onFocus',
    value: function _onFocus() {
      this._hideOrShow('focus');
    }
  }, {
    key: '_onClick',
    value: function _onClick() {
      this._hideOrShow('click');
    }
  }, {
    key: '_onMouseEnter',
    value: function _onMouseEnter() {
      this._hideOrShow('mouseenter');
    }
  }, {
    key: '_onMouseLeave',
    value: function _onMouseLeave() {
      this._hideOrShow('mouseleave');
    }
  }, {
    key: '_calculatePosition',
    value: function _calculatePosition(ref, tooltipNode) {
      if (!ref || !tooltipNode) {
        return {
          top: -1,
          left: -1
        };
      }
      return this._adjustPosition(position(this._getRect(this._childNode), this._getRect(tooltipNode), {
        placement: this.props.placement,
        alignment: this.props.alignment,
        margin: 10
      }, this.props.relative));
    }
  }, {
    key: '_updatePosition',
    value: function _updatePosition(ref) {
      if (ref && this._childNode) {
        var tooltipNode = ReactDOM.findDOMNode(ref);

        var style = this._calculatePosition(ref, tooltipNode);

        if (this.props.relative) {
          tooltipNode.style.top = style.top + 'px';
          tooltipNode.style.left = style.left + 'px';
        } else {
          tooltipNode.style.top = style.top + 'px';
          tooltipNode.style.left = Math.max(style.left, 0) + 'px';
        }

        var arrowStyles = this._adjustArrowPosition(this.props.placement, this.props.moveArrowTo);
        if (Object.keys(arrowStyles).length) {
          var arrow = tooltipNode.querySelector('.' + styles.arrow);
          arrow && Object.keys(arrowStyles).forEach(function (key) {
            arrow.style[key] = arrowStyles[key];
          });
        }
      }
    }
  }, {
    key: '_adjustArrowPosition',
    value: function _adjustArrowPosition(placement, moveTo) {
      if (moveTo) {
        var isPositive = moveTo > 0;
        var pixels = isPositive ? moveTo : -moveTo;
        if (['top', 'bottom'].includes(placement)) {
          return isPositive ? { left: pixels + 'px' } : { left: 'auto', right: pixels + 'px' };
        }
        return isPositive ? { top: pixels + 'px' } : { top: 'auto', bottom: pixels + 'px' };
      }
      return {};
    }
  }, {
    key: '_getRect',
    value: function _getRect(el) {
      if (this.props.appendToParent) {
        // TODO: Once thoroughly tested, we could use the same approach in both cases.
        return {
          left: el.offsetLeft,
          top: el.offsetTop,
          width: el.offsetWidth,
          height: el.offsetHeight
        };
      }
      return el.getBoundingClientRect();
    }
  }, {
    key: '_adjustPosition',
    value: function _adjustPosition(originalPosition) {
      var _ref4 = this.props.moveBy || {},
          _ref4$x = _ref4.x,
          x = _ref4$x === undefined ? 0 : _ref4$x,
          _ref4$y = _ref4.y,
          y = _ref4$y === undefined ? 0 : _ref4$y;
      // TODO: Once thoroughly tested, and converted to using offsetX props, we could remove this one.


      if (!this.props.appendToParent) {
        x += window.scrollX || 0;
        y += window.scrollY || 0;
      }
      return {
        left: originalPosition.left + x,
        top: originalPosition.top + y
      };
    }
  }, {
    key: '_onTooltipContentEnter',
    value: function _onTooltipContentEnter() {
      if (this.props.showTrigger === 'custom') {
        return;
      }
      this.show();
    }
  }, {
    key: '_onTooltipContentLeave',
    value: function _onTooltipContentLeave() {
      if (this.props.hideTrigger === 'custom') {
        return;
      }
      this._onMouseLeave();
    }
  }, {
    key: 'isShown',
    value: function isShown() {
      return this.state.visible;
    }
  }]);

  return Tooltip;
}(WixComponent);

Tooltip.propTypes = {
  textAlign: PropTypes.string,
  children: PropTypes.node,
  content: PropTypes.node.isRequired,
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  alignment: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'center']),
  theme: PropTypes.oneOf(['light', 'dark', 'error']),
  showDelay: PropTypes.number,
  hideDelay: PropTypes.number,
  showTrigger: PropTypes.oneOf(['custom', 'mouseenter', 'mouseleave', 'click', 'focus', 'blur']),
  hideTrigger: PropTypes.oneOf(['custom', 'mouseenter', 'mouseleave', 'click', 'focus', 'blur']),
  active: PropTypes.bool,
  bounce: PropTypes.bool,
  disabled: PropTypes.bool,
  maxWidth: PropTypes.string,
  onClickOutside: PropTypes.func,

  /**
   * Callback to be called when the tooltip has been shown
   */
  onShow: PropTypes.func,
  zIndex: PropTypes.number,

  /**
   * By default tooltip is appended to a body, to avoid CSS collisions.
   * But if you want your tooltip to scroll with a content, append tooltip to a parent.
   * Just make sure the CSS are not leaked.
   */
  appendToParent: PropTypes.bool,

  /**
   * Allows to shift the tooltip position by x and y pixels.
   * Both positive and negative values are accepted.
   */
  moveBy: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),

  /**
   * Allows to position the arrow relative to tooltip.
   * Positive value calculates position from left/top.
   * Negative one calculates position from right/bottom.
   */
  moveArrowTo: PropTypes.number,
  size: PropTypes.oneOf(['normal', 'large']),
  shouldCloseOnClickOutside: PropTypes.bool,
  relative: PropTypes.bool,

  /**
   * Allows changing the padding of the content
   */
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Tooltip.defaultProps = {
  placement: 'top',
  alignment: 'center',
  showTrigger: 'mouseenter',
  hideTrigger: 'mouseleave',
  showDelay: 200,
  hideDelay: 0,
  zIndex: 2000,
  maxWidth: '378px',
  onClickOutside: null,
  onShow: null,
  active: false,
  theme: 'light',
  disabled: false,
  children: null,
  size: 'normal',
  shouldCloseOnClickOutside: false,
  textAlign: 'center',
  relative: false
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this._childNode = null;
  this._mountNode = null;
  this._showTimeout = null;
  this._hideTimeout = null;
  this._unmounted = false;
  this.state = {
    visible: false,
    hidden: true
  };

  this._chainCallbacks = function (first, second) {
    return function (args) {
      if (first) {
        first.apply(_this6, args);
      }
      if (second) {
        second.apply(_this6, args);
      }
    };
  };
};

export default Tooltip;
//# sourceMappingURL=Tooltip.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Tooltip/Tooltip.js